export default "__VITE_ASSET__l0gX6for__"